/* This file contains predefined variables to avoid typo while dispatching*/

const REDIRECT_TO_ORDER = "REDIRECT_TO_ORDER"
const RESET_TO_ORDER_ID = "RESET_TO_ORDER_ID"

export const orderTypes = {
    REDIRECT_TO_ORDER,
    RESET_TO_ORDER_ID
}